const APPSLIST = {
  TITLE: 'لیست برنامه‌ها',
  DESCRIPTION:
    'اتصال سیستم پشتیبانی رایچت به سایر سیستم‌ها از طریق API، برای تعامل بهینه و همه‌جانبه.',
  ADD_APP_BUTTON: 'افزودن برنامه',
  USER_MANUAL_BUTTON: 'راهنمای استفاده',
  EMPTY_LIST_TITLE: 'شما هیچ برنامه‌ای اضافه نکرده‌اید',
  EMPTY_LIST_SUB_TITLE: 'اضافه کردن اولین برنامه',
  ADD_APP_MODAL_TITLE: 'افزودن برنامه',
  ADD_APP_MODAL_FIRST_PLACEHOLDER: 'عنوان برنامه *',
  ADD_APP_MODAL_SECOND_PLACEHOLDER: 'توضیحات برنامه *',
  ADD_APP_MODAL_ERROR_MESSAGE: 'پر کردن تمامی فیلدها الزامی می‌باشد!',
  SUCCESS_MODAL_TITLE: 'برنامه شما با موفقیت ایجاد شد',
  SUCCESS_MODAL_SUB_TITLE: 'اضافه کردن اولین برنامه',
  SUCCESS_MODAL_BUTTON: 'برو به لیست برنامه ها',
  COPY_MESSAGE: 'برای کپی کلیک کنید!',
  COPIED: 'کپی شد!',
  ACTIVE: 'فعال',
  NOT_ACTIVE: 'غیرفعال',
  DELETE_TITLE: 'حذف برنامه',
  DELETE_DESC: 'آیا از حذف برنامه اطمینان دارید؟',
  DELETE_CONFIRMATION_BTN: 'بله',
  DELETE_CANCEL_BTN: 'خیر',
  TITLE_ERROR_MESSAGE: 'نوشتن عنوان برنامه الزامی می‌باشد!',
  DESCRIPTION_ERROR_MESSAGE: 'نوشتن توضیحات برنامه الزامی می‌باشد!',
};

export default APPSLIST;
